import { Badge } from "@/components/ui/badge";
import { CheckCircle2, Clock, PlayCircle, XCircle, AlertCircle } from "lucide-react";

interface AssignmentStatusBadgeProps {
  status: "pending" | "accepted" | "declined" | "in_progress" | "completed" | "blocked";
  size?: "default" | "small";
}

export function AssignmentStatusBadge({ status, size = "default" }: AssignmentStatusBadgeProps) {
  const config = {
    pending: {
      label: "Pending",
      icon: Clock,
      variant: "outline" as const,
      className: "border-yellow-600 text-yellow-700 dark:text-yellow-500",
    },
    accepted: {
      label: "Accepted",
      icon: CheckCircle2,
      variant: "outline" as const,
      className: "border-blue-600 text-blue-700 dark:text-blue-400",
    },
    declined: {
      label: "Declined",
      icon: XCircle,
      variant: "outline" as const,
      className: "border-red-600 text-red-700 dark:text-red-400",
    },
    in_progress: {
      label: "In Progress",
      icon: PlayCircle,
      variant: "default" as const,
      className: "bg-blue-600 hover:bg-blue-700 text-white",
    },
    completed: {
      label: "Completed",
      icon: CheckCircle2,
      variant: "default" as const,
      className: "bg-green-600 hover:bg-green-700 text-white",
    },
    blocked: {
      label: "Blocked",
      icon: AlertCircle,
      variant: "destructive" as const,
      className: "",
    },
  };

  const { label, icon: Icon, variant, className } = config[status];
  const iconSize = size === "small" ? "h-3 w-3" : "h-4 w-4";

  return (
    <Badge variant={variant} className={`gap-1 ${className}`}>
      <Icon className={iconSize} />
      {label}
    </Badge>
  );
}
